import { SvgIcon } from '@mui/material'

const Battery9V = props => (
  <SvgIcon transform="translate(-2, 0)" {...props}>
    <g clipPath="url(#battery-9v-clip)">
      <path d="M19.5 5h-2V4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1h-2V4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1h-2c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m-7.92 9.48a2.9 2.9 0 0 1-.68 1.4c-.49.51-1.11.77-1.87.77s-1.31-.21-1.75-.63c-.43-.41-.65-.88-.65-1.41h1.39c.02.23.11.43.26.58.18.18.45.28.81.28.29 0 .54-.1.76-.31.35-.32.53-.91.53-1.75-.15.19-.37.33-.65.43-.27.09-.54.13-.8.13-.81 0-1.43-.23-1.87-.7-.43-.48-.65-1.11-.65-1.9s.23-1.41.68-1.9q.69-.75 1.95-.75c.7 0 1.28.22 1.73.66s.74 1.02.86 1.74c.08.45.12.93.12 1.43 0 .73-.05 1.38-.16 1.94zm4.79 2.02h-1.56l-2.58-7.8h1.51l1.89 5.95 1.88-5.95h1.43l-2.56 7.8z" />
      <path d="M9.04 9.93c-.4 0-.71.13-.92.4-.21.26-.31.63-.31 1.09 0 .42.11.76.32 1.03.22.26.53.4.93.4.36 0 .65-.14.86-.41q.33-.405.33-1.02c0-.44-.11-.8-.32-1.07-.21-.28-.5-.42-.89-.42" />
    </g>
    <defs>
      <clipPath id="battery-9v-clip">
        <path fill="#fff" d="M3.5 3h18v18h-18z" />
      </clipPath>
    </defs>
  </SvgIcon>
)

export default Battery9V
